import {Trans, useTranslation} from "react-i18next";
import React, {useState} from "react";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import {Container} from "@material-ui/core";
import {formatCurrency, supportMobileTemplates} from "../../../../../utils";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import {getNavigationUrl} from "../../../navigation";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Box from "@material-ui/core/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useShoppingCart} from "../../../hooks/shoppingcart";
import {Skeleton} from "@material-ui/lab";

const useStyles = makeStyles(theme => ({
    bottomMenuContainer: {
        width: '100%',
        padding: theme.spacing(2),
        boxSizing: 'border-box',
        backgroundColor: 'white',
        position: 'fixed',
        left: 0,
        bottom: 0,
        boxShadow: '0px -3px 6px #00000029',
        [theme.breakpoints.up('sm')]: {
            /*position: 'static'*/
        }
    },
    bottomButtonContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    bottomMenuQuantity: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: `0 ${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(2)}`,
        '& .MuiSkeleton-root': {
            minWidth: '100px'
        }
    },
    totalPrice: {
        fontWeight: 'bold',
    },
}));

const BottomMenu = ({totalPrice, totalQuantity}) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const [buyMore, setBuyMore] = useState(false)
    const theme = useTheme();
    const {updating} = useShoppingCart();
    const disableGutters = useMediaQuery(theme.breakpoints.down('sm'));

    const buyMoreButton = <Button component={Link} fullWidth to={'/products'} variant="contained" color="primary">
            <Trans>Order other products</Trans>
        </Button>

    return <Container disableGutters={disableGutters}>
        <div className={classes.bottomMenuPlaceHolder} />
        <div className={classes.bottomMenuContainer}>
            <div className={classes.bottomMenuQuantity}>
                <div>
                    {updating ? <Skeleton variant='text' /> : t('%d products', {postProcess: 'sprintf', sprintf: [totalQuantity] })}
                </div>
                <div className={classes.totalPrice}>
                    {updating ? <Skeleton variant='text' /> : formatCurrency(totalPrice)}
                </div>
            </div>
            <div className={classes.bottomButtonContainer}>
                <Button variant="contained" color="primary" onClick={() => setBuyMore(true)}>
                    <Trans>Order more</Trans>
                </Button>
                <Button  component={Link} to={getNavigationUrl('CHECKOUT')} variant="contained" color="primary">
                    <Trans>Proceed to payment</Trans>
                </Button>
            </div>
        </div>
        <Dialog
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="xs"
            open={buyMore}
        >
            <DialogTitle id="confirmation-dialog-title">
                <Trans>Please choose one of the options below</Trans>
            </DialogTitle>
            <DialogContent>
                <Box mb={4}>
                    <Trans>You may upload more photos or order other photo products here.</Trans>
                </Box>
                <Box mb={4}>
                    <Button fullWidth component={Link} to={getNavigationUrl('UPLOAD_PICTURES')}  variant="contained" color="primary">
                        <Trans>Upload more pictures</Trans>
                    </Button>
                </Box>
                <Box mb={2}>
                    {buyMoreButton}
                </Box>
            </DialogContent>
        </Dialog>
    </Container>
}

export default BottomMenu;